import { ProductCode, ProductType } from '@dev/ee-api/ee-api-models';

export enum PathParameters {
    NEW_RAW_HTML_TEMPLATE_CAMPAIGN_CREATOR = 'rawhtmltemplate',
    FROM_CAMPAIGN_CREATOR = 'campaigncreator',
}

export enum CampaignCreatorType {
    AB = 'ab-campaigncreator',
    REGULAR = 'regular-campaigncreator',
}

export const pathsParams = {
    segmentName: ':segmentname',
    listName: ':listname',
    contact: ':contact',
    msgId: ':msgId',
    productCode: ':productCode',
    name: ':name',
    nameOptional: ':name?',
    type: ':type',
    template: ':template?',
    overlayContact: ':overlaycontact',
    tab: ':tab?',
};

export const ActivityPaths = {
    DeviceDetails: '/activity/devicedetails',
    Geography: '/activity/geography',
};

export const ContactsPaths = {
    ContactsOverview: '/contacts/new/overview',
    ContactsUpload: '/contacts/new/upload',
    ContactsUploadImportMailchimp: '/contacts/new/upload/import-mailchimp',
    ContactsHistory: '/contacts/new/history',
    CustomFields: '/contacts/new/fields',
    ContactsAdd: '/contacts/new/add',
    Segments: '/contacts/new/segments',
    SegmentsByTarget: `/contacts/new/segment/${pathsParams.segmentName}/targets`,
    SingleSegment: `/contacts/new/segment/${pathsParams.segmentName}`,
    SegmentEditor: `/contacts/new/segment/edit/${pathsParams.segmentName}`,
    SegmentCreator: '/contacts/new/segments/create',
    Lists: '/contacts/new/lists',
    ListCreator: '/contacts/new/list/create/',
    ListEditor: `/contacts/new/list/edit/${pathsParams.listName}`,
    SingleList: `/contacts/new/list/${pathsParams.listName}`,
    CampaignsByTarget: `/contacts/new/list/${pathsParams.listName}/targets`,
    ListUpload: `/contacts/new/list/${pathsParams.listName}/upload`,
    ListAdd: `/contacts/new/list/${pathsParams.listName}/add`,
    SegmentAdd: `/contacts/new/segment/${pathsParams.segmentName}/add`,
    SegmentUpload: `/contacts/new/segment/${pathsParams.segmentName}/upload`,
    ListTargets: `/contacts/new/list/${pathsParams.listName}/targets`,
    EditList: `/contacts/new/list/edit/${pathsParams.listName}`,
    SingleContact: `/contacts/new/${pathsParams.contact}`,
    ListSingleContact: `/contacts/new/list/${pathsParams.listName}/${pathsParams.contact}`,
    SegmentSingleContact: `/contacts/new/segment/${pathsParams.segmentName}/${pathsParams.contact}`,
    EmailView: `/contacts/new/${pathsParams.contact}/${pathsParams.msgId}`,
    Contacts: '/contacts/new',
    ContactsOld: '/contacts',
    CampaignCreatorTarget: `/campaigncreator/target/${pathsParams.listName}`,
    CampaignCreatorTargetOld: `/campaigncreator/target/${pathsParams.listName}`,
    Unsubscribed: '/contacts/new/unsubscribed',
    DeviceDetails: '/contacts/new/device-details',
    Geography: '/contacts/new/geography',
};

export const LegacyPaths = {
    BuyLegacyIp: '/legacy#/account?buyip=true',
    Billing: '/legacy/#/payments',
};

export const HomePaths = {
    Home: '/',
    Dashboard: '/dashboard',
    AccountDeleted: '/account-delete-confirmation',
    Security: '/security',
    Reputation: '/reputation',
    Two_FA: '/security/two-factor-authentication',
    Account: '/account/',
    Automations: '/automations',
    AutomationNew: '/automations/editor/',
    Billing: LegacyPaths.Billing,
    Billing_noHash: LegacyPaths.Billing,
    BillingNew: '/billing',
    // Billing: '#/payments',
    // Billing_noHash: '/payments',
    ContentAnalysis: '/reputation/contentanalysis',
    ConfirmEmail: '/confirm-email',
    Help: '/help',
    Campaigns: '/campaigns',
    CampaignsNew: '/contacts/new',
    Templates: '/templates/new',
    Login: '/login',
    CreateAccount: '/create-account',
    RegisterUser: '/register',
    RegisterActivatedUser: '/alreadyregistered',
    ResetPassword: '/reset-password',
    Forgot: '/forgot',
    Unauthorized: `/401`,
    InternalServerError: `/500`,
    SERVICE_UNAVAILABLE: '/503',
    NotFound: '/404',
    SubAccounts: '/sub-accounts',
    ProfileInfo: '/personal-info',
    EditLPSubdomain: '/personal-info/edit-landing-pages-subdomain',
};

export const SettingsPaths = {
    Settings: '/settings/new',
    SystemOptions: '/settings/new/system-options',
    TrackingAndPruning: '/settings/new/tracking-and-pruning',
    Advanced: '/settings/new/advanced',
    Unsubscribe: '/settings/new/unsubscribe',
    UnsubscribeStandalone: '/settings/unsubscribe',
    Domains: '/settings/new/domains/',
    DomainsAdvanced: '/settings/new/domains/advanced',
    DomainsDomainVerification: '/settings/new/domains/domain-verification/',
    EmailAddressVerification: '/settings/new/domains/email-address-verification',
    DomainsEmailVerification: '/settings/new/domains/email-verification/',
    SingleDomainVerification: '/settings/new/domains/domain-verification/verify/:domainName?',
    SingleDomainBounceDomain: '/settings/new/domains/domain-verification/bounce-domain/:domainName',
    ManagePrivateIPs: '/settings/new/manage-private-ips',
    ManageInbounds: '/settings/new/manage-inbound-emails',
    EditInbound: '/settings/new/edit-inbound-email/:id',
    CreateInbound: '/settings/new/create-inbound-email',
    ManageWebhooks: '/settings/new/manage-webhooks',
    EditWebhook: '/settings/new/edit-webhook/:id',
    CreateWebhook: '/settings/new/create-webhook',
    ManageSMTP: '/settings/new/manage-smtp',
    ManageAPI: '/settings/new/manage-api',
    EditSMTP: '/settings/new/edit-smtp/:tokenName',
    EditAPI: '/settings/new/edit-api/:tokenName',
    CreateSMTP: '/settings/new/create-smtp',
    CreateAPI: '/settings/new/create-api',
    ManagePools: '/settings/new/manage-pools',
    SingleIP: '/settings/new/manage-private-ips/:singleIp',
    Billing: '#/payments',
    OldSettings: '#/settings',
};
export const CheckoutsPaths = {
    Checkouts: '/checkouts/:tabName?',
    CheckoutsList: '/checkouts/',
    CheckoutsDraftList: '/checkouts/draft',
    CheckoutCreator: `/checkouts/creator/${pathsParams.nameOptional}`,
    CheckoutsTab: '/checkouts/checkout',
    CheckoutsCreator: '/checkouts/creator',
};

export const AutomationPaths = {
    Automations: '/automations/:tabName?',
    AutomationsList: '/automations/',
    AutomationReport: '/automations/report/:name',
    AutomationsDraftList: '/automations/drafts',
    AutomationEditor: '/automations/editor/:name',
    AutomationNew: '/automations/editor/',
    AutomationsTab: '/automations/automations',
    AutomationPreview: '/automations/editor/:name/preview',
    ViewContacts: '/automations/report/:name/:recipientsType',
    OldAutomations: '#/automations',
};

export const CampaignsPaths = {
    Campaigns: '/campaigns/new/:view?',
    CampaignsTab: '/campaigns/new/campaigns',
    AutorespondersTab: '/campaigns/new/autoresponders',
    DratfsTab: '/campaigns/new/drafts',
    CampaignAbResults: '/campaigns/new/:type/:name/report/abresults',
    CampaignOverview: '/campaigns/new/:type/:name/report/overview',
    CampaignReport_BackendLinkInEmail: '/campaigns/new/:name/report/overview',
    CampaignReport: '/campaigns/new/:type/:name/report/:tab?',
    CampaignsEdit: '/campaigns/new/edit/',
    CampaignActivity: '/campaigns/new/:type/:name/report/activity',
    CampaignLinks: '/campaigns/new/:type/:name/report/links',
    CampaignLinkContacts: '/campaigns/new/:type/:name/report/:link/contacts',
    CampaignReportInProgress: '/campaigns/new/:type/:name/report/inprogress/overview',
    CampaignReportInProgressActivity: '/campaigns/new/:type/:name/report/inprogress/activity',
    CampaignReportAbSplitLinks: '/campaigns/new/:type/:name/links',
    CampaignGeography: '/campaigns/new/:type/:name/report/geography',
    OldCreateCampaign: '#/campaigncreator',
    CampaignCreator: `/new/${pathsParams.type}/`,
    CampaignCreatorName: `/new/${pathsParams.type}/${pathsParams.name}`,
    CampaignCreatorDetails: `/new/${pathsParams.type}/${pathsParams.name}/details`,
    CampaignCreatorTarget: `/new/${pathsParams.type}/target/${pathsParams.listName}`,
    CampaignCreatorTemplate: `/new/${pathsParams.type}/template/${pathsParams.template}`,
    OldBilling: '#/payments',
    OldViewCampaign: '#/campaigncreator/:name',
    OldCampaigns: '#/campaigns',
    NewCampaigns: '/campaigns/new',
    ViewCampaign: '/campaigncreator/:name',
};

export const TemplatesPaths = {
    TemplateList: '/templates/new',
    OldTemplateList: '/templates',
    OldCampaignCreator: '/campaigncreator',
    Campaingcreator: '/campaigncreator/template/:name/private',
    EditorLink: '/templates/new/editor',
    TemplateEditorName: '/templates/new/editor/:name?',
    DragDropEditor: '/templates/edit',
    PreviewLink: '/templates/new/preview/:name',
    PreviewLinkPublic: '/templates/new/preview/public/:name',
    CreateFromGallery: '/templates/create',
    LegacyCreateFromGallery: '/legacy/#/templates/create',
    CreateDragAndDrop: '/templates/create/dragdrop',
    LegacyDragDrop: '/legacy/#/templates/create/dragdrop',
    LegacyDragDropEditor: '/legacy/#/templates/edit',
    TemplateEditorLinkName: `/templates/editor/${pathsParams.template}`,
};

export const FormsPaths = {
    FormList: '/forms/new',
    FormCreator: `/forms/creator/${pathsParams.nameOptional}`,
    FormPopupCreator: `/forms/popup-creator/${pathsParams.nameOptional}`,
    OldFormList: '/forms',
    LegacyOldFormList: '/legacy/#/forms',
    FormsEditor: '/forms/edit',
    LegacyFormsEditor: '/legacy/#/forms/edit',
    CreateForms: '/forms/create',
    LegacyCreateForms: '/legacy/#/forms/create',
    Hash_CreateForms: '#/forms/create',
    CopyForm: '/forms/copy',
    LegacyCopyForm: '/legacy/#/forms/copy',
    CreateFromGallery: '/forms/gallerycopy',
    LegacyCreateFromGallery: '/legacy/#/forms/gallerycopy',
};

export const LandingPagePaths = {
    LandingPageList: '/landingpages/new',
    OldLandingPage: '/landingpages',
    EditorLink: '/landingpages/new/editor',
    TemplateEditorName: '/landingpages/new/editor/:name?',
    DragDropEditor: '/landingpages/edit',
    PreviewLink: '/landingpages/new/preview/:name',
    PreviewLinkPublic: '/landingpages/new/preview/public/:name',
    CreateFromGallery: '/landingpages/create',
    LegacyCreateFromGallery: '/legacy/#/landingpages/create',
    CreateDragAndDrop: '/landingpages/create/landingpage',
    LegacyDragDrop: '/legacy/#/landingpages/create/landingpage',
    Hash_CreateLandingPage: '#/landingpages/create/landingpage',
    LegacyDragDropEditor: '/legacy/#/landingpages/edit',
    LandingPageGalleryList: '/landingpages/new?tab=1',
    LandingPageCreator: `/landingpages/creator/${pathsParams.nameOptional}`,
};

export const ExportsPaths = {
    Exports: '/exports',
};

export const BillingPaths = {
    Billing: '/billing',
    BillingPlanList: `/billing/${pathsParams.productCode}/plans`,
    BillingPlansRenewal: '/billing/renewal',
    BillingPlansRenewalLegacy: '/legacy/#/account',
    AddPaymentMethod: '/billing/payment-methods/add',
};

export const DashboardPaths = {
    [ProductCode.EmailApi]: '/api',
    [ProductCode.EmailVerification]: '/evs',
    [ProductCode.Marketing]: '/marketing',
    [ProductCode.CreatorSuite]: '/creator',
    [ProductType.API]: '/api',
};

export const APIPaths = {
    unifiedDashManageSMTP: '/manage-smtp',
    unifiedDashManageAPI: '/manage-api',
    unifiedDashCreateAPI: '/create-api',
    unifiedDashCreateSMTP: '/create-smtp',
    unifiedDashEditAPI: '/edit-api/:tokenName',
    unifiedDashEditSMTP: '/edit-smtp/:tokenName',
    Logs: '/logs/:logType',
    LogsEmail: '/logs/email',
    LogsNotification: '/logs/notification',
    Statistics: '/activity',
    StatisticsLog: '/activity/inprogress/log',
    StatisticsInprogress: '/activity/inprogress',
    StatisticsChannels: '/activity/channels',
    StatisticsDeviceDetails: '/activity/device-details',
    StatisticsChannelOverview: '/activity/channels/:channelName/overview',
    StatisticsChannelLogs: '/activity/channels/:channelName/logs',
    StatisticsChannelLinkTracking: '/activity/channels/:channelName/linktracking',
    StatisticsChannelLinkTrackingContacts: '/activity/channels/:channelName/linktracking/contacts',
};

export const EVSPaths = {
    BulkVerification: '/evs/bulk',
    SingleFile: '/file/:id',
    VerificationsTabs: '/evs',
    SingleLead: '/singlelead',
};

export const SurveysPaths = {
    Onboarding: '/survey/onboarding',
};

export default {};
